// Import model
import { StartRoomSelectionAddLineItemRequest } from '../models/StartRoomSelectionAddLineItemRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartRoomSelectionAddLineItemRequest - handles JSON serialization and deserialization with type validation
 */
export class StartRoomSelectionAddLineItemRequestSerializer {
  /**
   * Deserializes a JSON string into a StartRoomSelectionAddLineItemRequest instance
   */
  static deserialize(json: string): StartRoomSelectionAddLineItemRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartRoomSelectionAddLineItemRequest instance
   */
  static fromObject(obj: any): StartRoomSelectionAddLineItemRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartRoomSelectionAddLineItemRequest');
    }


    const instance: StartRoomSelectionAddLineItemRequest = {
      itemId: obj['itemId'] as string | undefined,
      source: obj['source'] as string | undefined,
      quantity: obj['quantity'] as number | undefined,
      uom: obj['uom'] as string | undefined,
      appliesTo: obj['AppliesTo'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartRoomSelectionAddLineItemRequest instances
   */
  static deserializeArray(json: string): StartRoomSelectionAddLineItemRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartRoomSelectionAddLineItemRequest instance to a JSON string
   */
  static serialize(instance: StartRoomSelectionAddLineItemRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartRoomSelectionAddLineItemRequest instance to a plain object
   */
  static toObject(instance: StartRoomSelectionAddLineItemRequest): any {
    return {
      'itemId': instance.itemId,
      'source': instance.source,
      'quantity': instance.quantity,
      'uom': instance.uom,
      'AppliesTo': instance.appliesTo,
    };
  }

  /**
   * Serializes an array of StartRoomSelectionAddLineItemRequest instances to a JSON string
   */
  static serializeArray(instances: StartRoomSelectionAddLineItemRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
